import { render, staticRenderFns } from "./DocumentsCreate.vue?vue&type=template&id=546b29a7&scoped=true&"
import script from "./DocumentsCreate.vue?vue&type=script&lang=js&"
export * from "./DocumentsCreate.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCreate.vue?vue&type=style&index=0&id=546b29a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b29a7",
  null
  
)

export default component.exports